import PropTypes from 'prop-types';

import {
    // CartConfigType,
    CountriesType,
    RegionType,
    StoreItemType
} from 'SourceType/Config.type';
import {
    DISPLAY_CART_TAX_IN_PRICE,
    DISPLAY_CART_TAX_IN_SHIPPING,
    DISPLAY_CART_TAX_IN_SUBTOTAL,
    DISPLAY_CART_TAX_IN_TOTAL
} from 'Util/Cart';

export {
    // CartConfigType,
    CountriesType,
    RegionType,
    StoreItemType
};

export const ProFieldType = PropTypes.shape({
    code: PropTypes.string,
    label: PropTypes.string,
    type: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.string,
        label: PropTypes.string
    })),
    active: PropTypes.number,
    obligatoire: PropTypes.number,
    validation: PropTypes.number
});

export const ProFieldsType = PropTypes.arrayOf(ProFieldType);

export const CartConfigType = PropTypes.shape({
    display_tax_in_price: PropTypes.oneOf(Object.values(DISPLAY_CART_TAX_IN_PRICE)),
    display_tax_in_subtotal: PropTypes.oneOf(Object.values(DISPLAY_CART_TAX_IN_SUBTOTAL)),
    display_tax_in_shipping_amount: PropTypes.oneOf(Object.values(DISPLAY_CART_TAX_IN_SHIPPING)),
    include_tax_in_order_total: PropTypes.bool.isRequired,
    display_full_tax_summary: PropTypes.bool.isRequired,
    display_zero_tax_subtotal: PropTypes.bool.isRequired,
    display_tax_in_total: PropTypes.oneOf(Object.values(DISPLAY_CART_TAX_IN_TOTAL))
});
